// import React, { useRef, useEffect } from 'react';
// import { useForm, Controller } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import { TextField, Button, OutlinedInput } from '@mui/material';
// import { Send } from '@mui/icons-material';
// import * as yup from 'yup';

// const schema = yup.object().shape({
//   digit1: yup.number().required().integer().min(0).max(9),
//   digit2: yup.number().required().integer().min(0).max(9),
//   digit3: yup.number().required().integer().min(0).max(9),
//   digit4: yup.number().required().integer().min(0).max(9),
//   digit5: yup.number().required().integer().min(0).max(9),
//   digit6: yup.number().required().integer().min(0).max(9)
// });

// const inputStyle = {
//   fontSize: '24px',
//   fontWeight: 'bold',
//   textAlign: 'center'
// };
// function VerificationCode() {
//   const {
//     control,
//     handleSubmit,
//     formState: { errors },
//     setValue,
//     getValues
//   } = useForm({
//     resolver: yupResolver(schema)
//   });

//   // Refs for each input field
//   const digit1Ref = useRef(null);
//   const digit2Ref = useRef(null);
//   const digit3Ref = useRef(null);
//   const digit4Ref = useRef(null);
//   const digit5Ref = useRef(null);
//   const digit6Ref = useRef(null);

//   // Function to focus the next input field
//   const focusNextInput = (currentInputRef) => {
//     if (currentInputRef.current) {
//       currentInputRef.current.focus();
//     }
//   };

//   // useEffect(() => {
//   //   const currentValues = getValues();
//   //   const currentFieldOrder = ['digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6'];
//   //   const currentFocusedIndex = currentFieldOrder.findIndex((field) => !currentValues[field]);

//   //   console.log(currentValues);
//   //   console.log(currentFieldOrder);
//   //   console.log(currentFocusedIndex);

//   //   if (currentFocusedIndex !== -1 ) {
//   //     switch (currentFocusedIndex) {
//   //       case 0:
//   //         focusNextInput(digit1Ref);
//   //         break;
//   //       case 1:
//   //         focusNextInput(digit2Ref);
//   //         break;
//   //       case 2:
//   //         focusNextInput(digit3Ref);
//   //         break;
//   //       case 3:
//   //         focusNextInput(digit4Ref);
//   //         break;
//   //       case 4:
//   //         focusNextInput(digit5Ref);
//   //         break;
//   //       case 5:
//   //         focusNextInput(digit6Ref);
//   //         break;
//   //       default:
//   //         break;
//   //     }
//   //   }
//   // }, [getValues]);

//   const onSubmit = (data) => {
//     console.log(data); // You can send a request to the server here
//   };

//   return (
//     <form
//       onSubmit={handleSubmit(onSubmit)}
//       style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         width: '600px'
//       }}
//     >
//       <Controller
//         name="digit1"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit1 ? errors.digit1.message : ''}
//             ref={digit1Ref}
//             onKeyDown={(e) => {
//               if (e.key === 'Enter') {
//                 focusNextInput(digit2Ref);
//               }
//             }}
//           />
//         )}
//       />

//       <Controller
//         name="digit2"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit2 ? errors.digit2.message : ''}
//             ref={digit2Ref}
//           />
//         )}
//       />

//       <Controller
//         name="digit3"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit3 ? errors.digit3.message : ''}
//             ref={digit3Ref}
//           />
//         )}
//       />

//       <Controller
//         name="digit4"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit4 ? errors.digit4.message : ''}
//             ref={digit4Ref}
//           />
//         )}
//       />

//       <Controller
//         name="digit5"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit5 ? errors.digit5.message : ''}
//             ref={digit5Ref}
//           />
//         )}
//       />

//       <Controller
//         name="digit6"
//         control={control}
//         defaultValue=""
//         render={({ field }) => (
//           <OutlinedInput
//             sx={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}
//             {...field}
//             variant="outlined"
//             inputProps={{ maxLength: 1, style: inputStyle }} // InputProps={{ inputProps: { min: 0, max: 9, step: 1 } }}
//             error={!!errors.digit1}
//             helperText={errors.digit6 ? errors.digit6.message : ''}
//             ref={digit6Ref}
//           />
//         )}
//       />

//       <Button type="submit" variant="contained" endIcon={<Send />}>
//         Submit
//       </Button>
//     </form>
//   );
// }

// export default VerificationCode;

import React, { useRef, useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { OutlinedInput, Button } from '@mui/material';
import { Send } from '@mui/icons-material';
import * as yup from 'yup';
import axios from 'api/axios';
import { ACCOUNTS_URI, HOST, VERIFYCODE_URI } from 'variables';
import { verifyAccount } from 'store/reducers/account';
import { useDispatch } from 'react-redux';

const schema = yup.object().shape({
  digit1: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit2: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit3: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit4: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit5: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit6: yup.string().required().matches(/^\d$/, 'Must be a single digit'),
  digit7: yup.string().required().matches(/^\d$/, 'Must be a single digit')
});

const inputStyle = {
  fontSize: '24px',
  fontWeight: 'bold',
  textAlign: 'center'
};

const VERIFY_CODE_URL = HOST + ACCOUNTS_URI + VERIFYCODE_URI;
function VerificationCode() {
  const [isFocused, setIsFocused] = useState(false);
  const [disableAll, setDisableAll] = useState(false);
  const code = sessionStorage.getItem('verification-code');
  const dispatch = useDispatch();

  const handleFocus = () => {
    setIsFocused(true);
  };

  useEffect(() => {
    document.querySelector(`input[name=digit1]`).focus();
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    trigger,
    setValue
  } = useForm({
    resolver: yupResolver(schema)
  });

  useEffect(() => {
    if (code) {
      setValue('digit1', code[0]);
      setValue('digit2', code[1]);
      setValue('digit3', code[2]);
      setValue('digit4', code[3]);
      setValue('digit5', code[4]);
      setValue('digit6', code[5]);
      setValue('digit7', code[6]);
      setDisableAll(true);
    }
  }, []);

  const onSubmit = async (formData) => {
    let code = '';
    Object.keys(formData).forEach((key) => {
      code += formData[key];
    });

    const user_name = sessionStorage.getItem('username-to-be-reg');

    dispatch(verifyAccount({ code, user_name }));
  };

  const handleInput = async (field, index, e) => {
    const value = e.target.value;
    if (value.length === 1 && value.match(/^\d$/)) {
      setValue(field, value);
      await trigger(field);
      const nextField = `digit${index + 2}`;
      if (!errors[field] && nextField in schema.fields) {
        document.querySelector(`input[name=${nextField}]`).focus();
      } else if (!Object.keys(errors).length) {
        handleSubmit(onSubmit)();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      // If the current input has a value, clear it
      if (e.target.value !== '') {
        // Clear the current input
        e.target.value = '';
      }
      // If the current input is already empty, move to the previous input
      else if (index > 0) {
        const previousField = `digit${index}`;
        const previousInput = document.querySelector(`input[name=${previousField}]`);

        if (previousInput) {
          previousInput.focus();
        }
      }
    } else if (e.key === 'Enter') {
      const nextField = `digit${index + 2}`;

      if (nextField in schema.fields) {
        const nextInput = document.querySelector(`input[name=${nextField}]`);
        if (nextInput) {
          nextInput.focus();
        }
      } else {
        handleSubmit(onSubmit)();
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex justify-between w-full items-center space-x-8 sm:px-[10%] lg:px-[25%]">
      {[...Array(7)].map((_, index) => (
        <Controller
          key={index}
          name={`digit${index + 1}`}
          control={control}
          defaultValue=""
          render={({ field }) => (
            <OutlinedInput
              {...field}
              className="flex items-center justify-center text-center"
              // ref={index === 0 ? firstInputRef : null}
              inputProps={{ maxLength: 1, style: inputStyle }}
              error={!!errors[`digit${index + 1}`]}
              // helperText={errors[`digit${index + 1}`] ? errors[`digit${index + 1}`].message : ''}
              onChange={(e) => handleInput(`digit${index + 1}`, index, e)}
              // onFocus={handleFocus}
              // disabled={!isFocused && index !== 0}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          )}
        />
      ))}
      {/* <Button type="submit" variant="contained" endIcon={<Send />}>
        Submit
      </Button> */}
    </form>
  );
}

export default VerificationCode;
